<template>
  <div class="container-box">
    <div class="company-hd">
      <div
        class="company-hd-banner"
        v-if="hdData.banner"
        v-bind:style="{ backgroundImage: 'url(' + hdData.banner + ')' }"
      ></div>
      <div class="company-hd-inner">
        <el-image
          class="company-hd-img"
          cover
          v-if="nowCompLogo"
          :src="nowCompLogo"
        ></el-image>
        <div class="company-hd-content">
          {{ hdData.comp_name }}
          <span style="font-size: 22px">校园招聘真题训练专区</span>
        </div>
        <div class="company-hd-right" v-if="hdData.qr_code">
          <div class="company-hd-right-content">
            <div style="padding: 0 0 6px 36px">关注微信号</div>
            <div>获取最新职位信息</div>
          </div>
          <el-image class="qrcode-img" :src="hdData.qr_code" cover></el-image>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="company-bd">
        <div class="company-bd-middle">
          <company-code-cell :baseInfo="baseInfo" />
        </div>
        <div class="company-bd-content">
          <company-code-box
            v-for="(item, index) in companyList"
            :key="index"
            :compLogo="nowCompLogo"
            :compName="hdData.comp_name"
            :item="item"
          />
          <my-pagination
            class="company-bd-pagination"
            @changeSizeHandle="changeSizeHandle"
            @currentChangeHandle="currentChangeHandle"
            :currentPage="currentPage"
            :size="pageSize"
            :total="total"
            background
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LOGIN_API } from "@/api.js";
import CompanyCodeBox from '@/components/practice/company-code-box'
import CompanyCodeCell from '@/components/practice/company-code-cell'
import { hdData, companyCellItems } from './config'
export default {
  data() {
    return {
      hdData: hdData,

      total: 0, // 总条数
      pageSize: 8,
      currentPage: 1,

      nowCompLogo: '',
      nowCompCode: '',
      companyList: [],

      baseInfo: companyCellItems,
    }
  },
  components: {
    CompanyCodeBox,
    CompanyCodeCell,
  },
  mounted() {
    const { compCode } = this.$route.query || ''
    this.nowCompCode = compCode
    this.getInitLoadConfig()
    this.getPositionList()
    this.getCompanyInfo()
    window.scrollTo(0, 0)
  },
  methods: {
    changeSizeHandle(val) {
      this.pageSize = val // 改变每页显示的条数
      this.getPositionList()
    },
    currentChangeHandle(val) {
      this.currentPage = val // 改变默认的页数
      this.getPositionList() // 切换页码时，要获取每页显示的条数
    },
    getInitLoadConfig() {
      let _this = this
      let post = {
        category: 7,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            let list = res.data.result[0]
            if (list.data) {
              let company = list.data.filter(
                (item) => item.compCode == _this.nowCompCode
              )
              if (company.length > 0) {
                const compInfo = company[0]
                if (compInfo) {
                  _this.hdData.banner = compInfo.bannerBg
                  _this.hdData.qr_code = compInfo.weixin
                  _this.hdData.title = compInfo.compTitle
                  _this.hdData.comp_name = compInfo.compName.replace('2', '')
                  _this.nowCompLogo = compInfo.compLogo
                }
              }
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    getPositionList() {
      let post = {
        compCode: this.nowCompCode.toString(),
        pageSize: parseInt(this.pageSize),
        pageNum: parseInt(this.currentPage),
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/positionList`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result) {
              this.total = res.data.result.count
              this.companyList = res.data.result.position

              this.total ? (this.baseInfo[1].num = this.total) : null
              let cands_num = 0
              this.companyList.map((item) => {
                cands_num += Number(item.basePractiseCount)
              })
              this.baseInfo[3].num = cands_num
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    getCompanyInfo() {
      this.$axios
        .get(
          `${LOGIN_API}/customer/api/examHistory/` +
            this.nowCompCode
        )
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result) {
              let result = res.data.result
              result.paperCategory
                ? (this.baseInfo[0].num = result.paperCategory)
                : null
              result.questionCount
                ? (this.baseInfo[2].num = result.questionCount)
                : null
              result.practiseCount
                ? (this.baseInfo[3].num = result.practiseCount)
                : null
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
  },
}
</script>

<style lang='scss' scoped>
.container-box {
  width: 100%;
  margin: auto;
  background-color: #fff;

  .company-hd {
    border-bottom: 1px solid #eff0f2;
    .company-hd-banner {
      height: 370px;
      background-repeat: no-repeat;
      background-position: center top;
      background-size: cover;
    }
    .company-hd-img {
      font-size: 15px;
      display: inline-table;
      margin: auto 0px;
      max-height: 80px;
    }
    .company-hd-inner {
      position: relative;
      display: flex;
      color: #666;
      width: 900px;
      height: 104px;
      background-color: #fff;
      margin: auto;
      font-weight: 300;
      .company-hd-content {
        font-size: 24px;
        margin: auto 0;
        padding: 0 30px;
      }
      .company-hd-right {
        position: absolute;
        right: -6px;
        display: flex;
        .qrcode-img {
          max-height: 90px;
          margin: 8px 0px 10px 4px;
          max-width: 90px;
        }

        .company-hd-right-content {
          margin: auto;
          font-size: 12px;
        }
        img {
          height: 100px;
        }
      }
    }
  }
  .box {
    background: #fff url('/static/images/wbg.png') repeat-x;
    .company-bd {
      width: 900px;
      margin: 0 auto;
      margin-top: 15px;

      .company-bd-content {
        width: 920px;
        padding: 20px 0px;
      }
      .company-bd-pagination {
        margin-right: 20px;
      }
    }
  }
}
</style>
<style>
.company-hd-img img {
  height: initial;
  width: initial;
  max-width: 200px;
  max-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/pages/practice/company-code/index.vue